var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reservation-page',{scopedSlots:_vm._u([{key:"checkedin",fn:function(ref){
var reservation = ref.reservation;
var property = ref.property;
return [_c('reservation-checkedin-page',{attrs:{"reservation":reservation,"property":property}},[_c('h2',{staticClass:"headline my-5"},[_vm._v("Guests")]),_c('reservation-guests',{attrs:{"reservation":reservation,"include-primary-guest":true}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }